import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/tailwind.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faArrowUpRightFromSquare,
  faLink,
  faSpinner,
  faTimes,
  faLaptopCode,
  faDumbbell,
  faCashRegister,
  faNetworkWired,
} from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faInstagram,
  faLinkedin,
  faTwitter,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

library.add(
  faWhatsapp,
  faTwitter,
  faLinkedin,
  faInstagram,
  faGithub,
  faEnvelope,
  faArrowUpRightFromSquare,
  faLink,
  faSpinner,
  faTimes,
  faLaptopCode,
  faDumbbell,
  faCashRegister,
  faNetworkWired
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js");
  });
}

createApp(App)
  .use(router)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
